import { useMutation } from "react-query";
import { saveMultiMeasurements } from "components/measuring/lib/measuring-data";
import * as notify from "shared/notify";

export const useSaveMeasurements = () => {
    return useMutation(({ measurement, wipKeys }) => saveMultiMeasurements(measurement, wipKeys), {
        onError: () => notify.error("Unable to save measurement"),
    });
};
